import { createStyles } from "@mantine/emotion";

export const useStyles = createStyles(() => ({
  /**
   * Pinned to the bottom-centre rather than across the top: the top-right is
   * already the ToastContainer's territory, and a full-width top bar would sit
   * over the navbar logo on every layout. A bottom pill stays clear of both and
   * of the primary action buttons, which sit left-aligned above it.
   *
   * `pointerEvents: none` matters — this is a status indicator, not a dialog.
   * Nothing underneath it should become unclickable just because the network
   * dropped; the whole point is that the user keeps reading the page they have.
   */
  bar: {
    position: "fixed",
    bottom: 20,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 9999,
    pointerEvents: "none",

    display: "flex",
    alignItems: "center",
    gap: 10,
    maxWidth: "calc(100vw - 32px)",
    padding: "10px 18px",
    borderRadius: 999,

    fontSize: 13.5,
    fontWeight: 500,
    lineHeight: 1.35,
    boxShadow: "0 6px 20px rgba(16, 24, 40, 0.18), 0 1px 3px rgba(16, 24, 40, 0.10)",

    animation: "fh-offline-in 180ms ease-out",
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
    "@keyframes fh-offline-in": {
      from: { opacity: 0, transform: "translate(-50%, 8px)" },
      to: { opacity: 1, transform: "translate(-50%, 0)" },
    },
  },

  // Offline — slate rather than red. This is a condition of the user's own
  // network, not an error the app committed or that they need to act on
  // urgently; red would overstate it every time a train enters a tunnel.
  offline: {
    background: "#28323F",
    color: "#FFFFFF",
    border: "1px solid #28323F",
  },

  // Restored — brand green, and short-lived (see the component). Closes the
  // loop so the user knows to retry, rather than leaving them guessing whether
  // the banner simply vanished.
  online: {
    background: "#E6F6F4",
    color: "#0F5C55",
    border: "1px solid #9AD5CE",
  },

  icon: {
    flex: "0 0 auto",
    display: "block",
  },

  text: {
    minWidth: 0,
  },
}));
